import * as React from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TableSkeleton from "../../loader/tableLoader";
import {getDefaultOperator} from "../../../container/leads/common/filters/LeadsCustomFilters";
export const CustomFilterableDataGrid = ({
  filterPanel,
  filters,
  toolbarPanel,
  onFilterModelChange,
  ...props
}) => {
  const [filterButtonEl, setFilterButtonEl] = React.useState(null);

  const handleFilterModelChange = (newFilterModel) => {
    console.log("🔍 CustomFilterableDataGrid received:", newFilterModel);
    
    if (onFilterModelChange) {
      // ✅ FIXED: Keep ALL properties from MUI, don't strip them
      // MUI uses 'operator', we need to preserve it as 'operatorValue'
      const convertedFilters = newFilterModel.items.map((filter) => {
        const normalized = {
          id: filter.id,
          field: filter.field,
          columnField: filter.field, // MUI uses 'field', we keep both
          operator: filter.operator, // Keep MUI's 'operator'
          operatorValue:filter.operator==="contains" && !filter?.operatorValue?"":  filter.operatorValue || getDefaultOperator(filter.field), // Also set 'operatorValue' for our components
          value: filter.value,
        };
      
        return normalized;
      });

      onFilterModelChange({
        items: convertedFilters,
        logicOperator: newFilterModel.logicOperator || "and",
      });
    }
  };

  const handleColumnHeaderClick = (params, event) => {
    if (event.target.closest('[data-testid="columnHeaderDragger"]')) {
      return;
    }
    setFilterButtonEl(event.currentTarget);
  };

  // Normalize incoming filters to ensure both 'field' and 'operator' exist
  const normalizedFilters = React.useMemo(() => {
    console.log("📋 Normalizing incoming filters:", filters);
    
    return (filters || []).map((filter) => {
      const normalized = {
        ...filter,
        id: filter.id,
        field: filter.columnField || filter.field, // MUI expects 'field'
        operator: filter.operatorValue || filter.operator || "contains", // MUI expects 'operator'
        value: filter.value,
      };
      
      console.log("🔄 Filter normalization:", { from: filter, to: normalized });
      return normalized;
    });
  }, [filters]);

  return (
    <DataGridPro
      {...props}
      filterModel={{
        items: normalizedFilters,
        logicOperator: "and",
      }}
      onFilterModelChange={handleFilterModelChange}
      slots={{
        filterPanel: filterPanel,
        toolbar: toolbarPanel,
        loadingOverlay: TableSkeleton,
      }}
      slotProps={{
        toolbar: {
          setFilterButtonEl,
        },
        filterPanel: {
          apiRef: props?.apiRef,
          setFilterButtonEl,
          anchorEl: filterButtonEl,
          onClose: () => setFilterButtonEl(null),
          onFilterModelChange: (model) => handleFilterModelChange(model),
        },
      }}
      onColumnHeaderClick={handleColumnHeaderClick}
      disableColumnMenu={false}
      disableColumnResize={false}
    />
  );
};